import { TypeQuickLinksWithoutUnresolvableLinksResponse } from 'contentful-types'

import { withContentful } from 'src/siteBuilder/renderer/contentful/withContentful'
import { mapSpacer } from 'src/siteBuilder/renderer/contentful/mapSpacer'

import QuickLinks from './QuickLinks'

const ContentfulQuickLinks = withContentful<TypeQuickLinksWithoutUnresolvableLinksResponse['fields']>(QuickLinks, {
  spacer: mapSpacer,
  quickLinksItem: (props) => {
    return props.fields.quickLinksItem
      .filter((item) => item && item.fields)
      .map((item) => ({
        text: item.fields.text,
        href: item.fields.href,
        icon: item.fields.icon,
      }))
  },
})

export default ContentfulQuickLinks
